import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'

/**
 * Client-side CSV / Excel export of a Sentinel v2 result table.
 * v2 returns rows inline, so a download needs no extra network call (and never
 * touches the Sentinel service). Uses the xlsx + file-saver deps already present.
 */
function tableToWorksheet(columns, rows) {
  return XLSX.utils.aoa_to_sheet([columns, ...rows])
}

export function downloadTableCSV(columns, rows, fileName = 'Sentinel') {
  const ws = tableToWorksheet(columns, rows)
  const csv = XLSX.utils.sheet_to_csv(ws)
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  saveAs(blob, `${fileName}.csv`)
}

export function downloadTableXLSX(columns, rows, fileName = 'Sentinel') {
  const ws = tableToWorksheet(columns, rows)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Sentinel')
  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([out], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  saveAs(blob, `${fileName}.xlsx`)
}
